"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.descriptionCss = exports.imageProps = exports.cardCss = void 0;
const cardCss = {
  small: {
    width: 184,
    height: 240,
    borderRadius: 12
  },
  large: {
    width: 219,
    height: 360,
    borderRadius: 16
  }
};
exports.cardCss = cardCss;
const imageProps = {
  small: {
    with: '100%',
    height: 128,
    padding: [12, 4]
  },
  large: {
    with: '100%',
    height: 208,
    padding: [12, 8]
  }
};
exports.imageProps = imageProps;
const descriptionCss = {
  small: [8],
  large: [8, 16, 16]
};
exports.descriptionCss = descriptionCss;
//# sourceMappingURL=EventCard.theme.js.map